<template>
  <CommonPages id="explore-city" :classs="['explore-city']" :titlePrefix="pageMetaTitle"
    :metaDescription="pageMetaDescription">
    <div class="explore-city__container">
      <section class="explore-city__title-block">
        <h1 class="explore-city__title">{{ cityData.name }}</h1>
        <div class="explore-city__chips">
          <div class="explore-city__chip" v-for="chip in cityData.chips" :key="chip.label">
            <span class="explore-city__chip-label">{{ chip.label }}:</span>
            <span class="explore-city__chip-value">{{ chip.value }}</span>
          </div>
        </div>
      </section>

      <section class="explore-city__overview">
        <div v-if="deviceType == 'mobile' && exploreCityAds.heroTop"
          class="explore-city__ad-block explore-city__ad-block--hero-top">
          <AdComponent class="ad-width-100" :ads="exploreCityAds.heroTop" :showDebug="showDebug"
            :forceDebug="true" debugLabel="explore_city_ad_1" debugPosition="城市图片上方（仅移动端）"
            @adCollapsed="hideExploreCityAd('heroTop')" />
        </div>

        <div class="explore-city__hero" @mouseenter="stopHeroAutoplay"
          @mouseleave="startHeroAutoplay">
          <div class="explore-city__hero-image"
            :style="{ backgroundImage: `url(${currentHeroSlide.image})` }">
          </div>
          <div v-if="deviceType != 'mobile' && currentHeroSlide.quote" class="explore-city__hero-overlay">
            <p class="explore-city__quote">{{ currentHeroSlide.quote }}</p>
            <div class="explore-city__quote-meta">
              <span class="explore-city__quote-author">{{ currentHeroSlide.author }}</span>
              <span class="explore-city__dots">
                <button v-for="(_, index) in heroSlides" :key="index" class="explore-city__dot"
                  :class="{ 'is-active': index === heroSlideIndex }" type="button"
                  :aria-label="`Go to slide ${index + 1}`" @click="setHeroSlide(index)"></button>
              </span>
            </div>
          </div>
        </div>

        <div v-if="deviceType != 'mobile' && exploreCityAds.heroBottom"
          class="explore-city__ad-block explore-city__ad-block--hero">
          <AdComponent class="ad-width-100" :ads="exploreCityAds.heroBottom" :showDebug="showDebug"
            :forceDebug="true" debugLabel="explore_city_ad_1" debugPosition="城市图片下方（仅PC）"
            @adCollapsed="hideExploreCityAd('heroBottom')" />
        </div>

        <div v-if="deviceType == 'mobile' && currentHeroSlide.quote" class="explore-city__quote-panel">
          <p class="explore-city__quote">{{ currentHeroSlide.quote }}</p>
          <div class="explore-city__quote-meta">
            <span class="explore-city__quote-author">{{ currentHeroSlide.author }}</span>
            <span class="explore-city__dots">
              <button v-for="(_, index) in heroSlides" :key="index" class="explore-city__dot"
                :class="{ 'is-active': index === heroSlideIndex }" type="button"
                :aria-label="`Go to slide ${index + 1}`" @click="setHeroSlide(index)"></button>
            </span>
          </div>
        </div>

        <div v-if="deviceType == 'mobile' && exploreCityAds.quoteBelow"
          class="explore-city__ad-block explore-city__ad-block--quote">
          <AdComponent class="ad-width-100" :ads="exploreCityAds.quoteBelow" :showDebug="showDebug"
            :forceDebug="true" debugLabel="explore_city_ad_2" debugPosition="名言卡片下方（仅移动端）"
            @adCollapsed="hideExploreCityAd('quoteBelow')" />
        </div>

        <div class="explore-city__metrics">
          <button class="explore-city__metric" v-for="metric in cityData.metrics" :key="metric.name"
            :class="{ 'is-active': metric.active }" @click="scrollToMetric(metric.key)">
            <div class="explore-city__metric-left">
              <img class="explore-city__metric-icon" :src="metric.icon"
                :alt="`${metric.name} icon`">
              <span class="explore-city__metric-name">{{ metric.name }}</span>
            </div>
            <div class="explore-city__metric-right">
              <span class="explore-city__metric-value">{{ metric.value }}</span>
              <img class="explore-city__metric-arrow" :src="metric.arrowIcon" alt="arrow">
            </div>
          </button>
        </div>
      </section>

      <section v-if="cityData.details.length" class="explore-city__details">
        <template v-for="(detail, index) in cityData.details">
          <div v-if="deviceType == 'mobile' && index === 2 && exploreCityAds.livingCostAbove"
            :key="`${detail.title}-mobile-ad`" class="explore-city__ad-block explore-city__ad-block--detail">
            <AdComponent class="ad-width-100" :ads="exploreCityAds.livingCostAbove"
              :showDebug="showDebug" :forceDebug="true" debugLabel="explore_city_ad_3"
              debugPosition="第三点 Living Cost 文本上方（仅移动端）"
              @adCollapsed="hideExploreCityAd('livingCostAbove')" />
          </div>
          <div v-if="deviceType != 'mobile' && index === 3 && exploreCityAds.healthcareAbove"
            :key="`${detail.title}-pc-ad`" class="explore-city__ad-block explore-city__ad-block--detail">
            <AdComponent class="ad-width-100" :ads="exploreCityAds.healthcareAbove"
              :showDebug="showDebug" :forceDebug="true" debugLabel="explore_city_ad_2"
              debugPosition="第四点 Healthcare 文本上方（仅PC）"
              @adCollapsed="hideExploreCityAd('healthcareAbove')" />
          </div>
          <article class="explore-city__detail" :key="detail.title" :ref="`metric-${detail.key}`">
            <h2 class="explore-city__detail-title">{{ detail.title }}</h2>
            <p v-if="detail.body" class="explore-city__detail-text">{{ detail.body }}</p>
          </article>
        </template>
      </section>

      <div v-if="cityData.details.length && deviceType != 'mobile' && exploreCityAds.relatedAbove"
        class="explore-city__ad-block explore-city__ad-block--related">
        <AdComponent class="ad-width-100" :ads="exploreCityAds.relatedAbove" :showDebug="showDebug"
          :forceDebug="true" debugLabel="explore_city_ad_3" debugPosition="Explore More 模块上方（仅PC）"
          @adCollapsed="hideExploreCityAd('relatedAbove')" />
      </div>

      <section class="explore-city__related">
        <h3 class="explore-city__related-title">{{ relatedTitle }}</h3>
        <div class="explore-city__related-grid">
          <a v-for="card in relatedCities" :key="card.slug" class="explore-city__city-card"
            :href="getPageUrl(`/${card.slug}`)">
            <div class="explore-city__city-bg" :style="{ backgroundImage: `url(${card.image})` }">
            </div>
            <div class="explore-city__city-mask"></div>
            <div class="explore-city__city-name">{{ card.name }}</div>
          </a>
        </div>
      </section>

    </div>
  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue';
import AdComponent from '@/pages/components/AdComponent.vue';
import { mapGetters } from 'vuex';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import { getContentTextMap, getText, renderTemplate } from '@/utils/contentText';
import { getRenderableAd } from '@/utils/adConfig';

const PLACEHOLDER_IMAGE = require('@/assets/default/placeholder.png');
const METRIC_REGION_ICON = require('@/assets/explore/info-region.svg');
const METRIC_AIR_ICON = require('@/assets/explore/info-air-quality.svg');
const METRIC_SAFETY_ICON = require('@/assets/explore/info-safety.svg');
const METRIC_COST_ICON = require('@/assets/explore/info-living-cost.svg');
const METRIC_HEALTH_ICON = require('@/assets/explore/info-healthcare.svg');
const METRIC_TRANSPORT_ICON = require('@/assets/explore/info-transport.svg');
const METRIC_ARROW_ICON = require('@/assets/explore/info-arrow.svg');

const METRIC_OPTIONS = [
  { key: 'airQuality', name: 'Air Quality', icon: METRIC_AIR_ICON },
  { key: 'safety', name: 'Safety', icon: METRIC_SAFETY_ICON },
  { key: 'livingCost', name: 'Living Cost', icon: METRIC_COST_ICON },
  { key: 'healthcare', name: 'Healthcare', icon: METRIC_HEALTH_ICON },
  { key: 'transport', name: 'Transport', icon: METRIC_TRANSPORT_ICON },
];

const EMPTY_METRIC_VALUE = 'N/A';

function getMetricDetail (city, key) {
  return city.metricDetails?.[key] || {};
}

function getMetricValue (city, key) {
  return getMetricDetail(city, key).value || city.metrics?.[key] || EMPTY_METRIC_VALUE;
}

function getMetricDescription (city, key) {
  return getMetricDetail(city, key).description || '';
}

function slugToName (slug) {
  return (slug || 'tokyo')
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

function buildMetricItems (city, activeMetricKey) {
  return [
    {
      key: 'region',
      icon: METRIC_REGION_ICON,
      name: 'Region',
      value: city.region,
      arrowIcon: METRIC_ARROW_ICON,
    },
    ...METRIC_OPTIONS.map((item) => ({
      key: item.key,
      icon: item.icon,
      name: item.name,
      value: getMetricValue(city, item.key),
      arrowIcon: METRIC_ARROW_ICON,
      active: activeMetricKey === item.key,
    })),
  ];
}

function buildDetailItems (city) {
  return METRIC_OPTIONS.map((item) => {
    const metricValue = getMetricValue(city, item.key);
    return {
      key: item.key,
      name: item.name,
      metricValue,
      body: getMetricDescription(city, item.key),
    };
  }).filter((item) => item.body).map((item, index) => ({
    key: item.key,
    title: `${index + 1}、${item.name}: ${item.metricValue}`,
    body: item.body,
  }));
}

function buildCityChips (city) {
  return [
    { label: 'Nation', value: city.country || 'Unknown' },
    { label: 'Overall Score', value: `${city.score}/10` },
    { label: 'Language', value: city.language || 'English' },
  ];
}

export default {
  name: 'ExploreCityPage',
  components: {
    CommonPages,
    AdComponent
  },
  mixins: [adMixin, adTrackingMixin],
  data () {
    return {
      activeMetricKey: '',
      heroSlideIndex: 0,
      heroTimer: null,
      hiddenAdSlots: {},
    };
  },
  computed: {
    ...mapGetters(['livableCityData', 'adsensConfig', 'showDebug', 'deviceType', 'domainConfig']),
    contentText () {
      return getContentTextMap(this.domainConfig);
    },
    pageMetaTitle () {
      const fallback = `${this.cityData.name} Livability`
      return this.renderCityTemplate(getText(this.contentText, 'CITY_META_TITLE', fallback));
    },
    pageMetaDescription () {
      const fallback = this.cityData.metaDescription || 'An in-depth exploration of urban life. Access a full dossier including essential data, linguistic context, and a rigorous breakdown of our five core livability indicators.'
      return this.renderCityTemplate(getText(this.contentText, 'CITY_META_DESCRIPTION', fallback));
    },
    relatedTitle () {
      return 'Explore More Livable Cities';
    },
    citySlug () {
      return (this.$route.params.cityname || 'tokyo').toLowerCase();
    },
    cityName () {
      return slugToName(this.citySlug);
    },
    cityTemplateData () {
      return {
        city: this.cityData.name,
        CITY: this.cityData.name,
      };
    },
    currentCity () {
      const found = (this.livableCityData.cities || []).find((city) => city.slug === this.citySlug);
      return found || (this.livableCityData.cities || [])[0] || null;
    },
    cityData () {
      const city = this.currentCity;
      if (!city) {
        return {
          name: this.cityName,
          metaDescription: '',
          chips: [],
          metrics: [],
          details: [],
        };
      }
      return {
        name: city.name,
        metaDescription: `Understand ${city.name} with livability scores for air quality, safety, living cost, healthcare and transport.`,
        chips: buildCityChips(city),
        metrics: buildMetricItems(city, this.activeMetricKey),
        details: buildDetailItems(city),
      };
    },
    heroSlides () {
      const city = this.currentCity;
      if (!city) {
        return [];
      }
      const quotes = city.cityQuotes || [];
      return quotes.map((item) => ({
        image: city.image || PLACEHOLDER_IMAGE,
        quote: item.text,
        author: item.author ? `— ${item.author}` : '',
      }));
    },
    currentHeroSlide () {
      return this.heroSlides[this.heroSlideIndex] || {
        image: this.currentCity?.image || PLACEHOLDER_IMAGE,
        quote: '',
        author: '',
      };
    },
    relatedCities () {
      const source = (this.livableCityData.cities || []).filter((city) => city.slug !== this.citySlug);
      const seed = this.citySlug.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
      const sorted = source.sort((a, b) => {
        const aVal = (a.slug.length * 13 + seed) % 101;
        const bVal = (b.slug.length * 13 + seed) % 101;
        return aVal - bVal;
      });
      return sorted.slice(0, 4);
    },
    exploreCityAds () {
      const cfg = this.adsensConfig || {};
      return {
        heroTop: this.deviceType == 'mobile' ? getRenderableAd(cfg.introduce_1) : null,
        heroBottom: this.deviceType == 'mobile' ? null : getRenderableAd(cfg.introduce_1),
        quoteBelow: this.deviceType == 'mobile' ? getRenderableAd(cfg.introduce_2) : null,
        healthcareAbove: this.deviceType == 'mobile' ? null : getRenderableAd(cfg.introduce_2),
        livingCostAbove: this.deviceType == 'mobile' ? getRenderableAd(cfg.introduce_3) : null,
        relatedAbove: this.deviceType == 'mobile' ? null : getRenderableAd(cfg.introduce_3),
      };
    },
  },
  mounted () {
    this.startHeroAutoplay();
  },
  beforeDestroy () {
    this.stopHeroAutoplay();
  },
  watch: {
    citySlug () {
      this.activeMetricKey = '';
      this.heroSlideIndex = 0;
      this.resetExploreCityAds();
      this.startHeroAutoplay();
    },
  },
  methods: {
    startHeroAutoplay () {
      this.stopHeroAutoplay();
      if (this.heroSlides.length <= 1) {
        return;
      }
      this.heroTimer = setInterval(() => {
        this.nextHeroSlide();
      }, 3000);
    },
    stopHeroAutoplay () {
      if (!this.heroTimer) {
        return;
      }
      clearInterval(this.heroTimer);
      this.heroTimer = null;
    },
    nextHeroSlide () {
      this.heroSlideIndex = (this.heroSlideIndex + 1) % this.heroSlides.length;
    },
    setHeroSlide (index) {
      this.heroSlideIndex = index;
      this.startHeroAutoplay();
    },
    scrollToMetric (key) {
      if (key === 'region') {
        return;
      }
      this.activeMetricKey = key;
      const refKey = `metric-${key}`;
      const target = this.$refs[refKey];
      const node = Array.isArray(target) ? target[0] : target;
      if (!node || typeof window === 'undefined') {
        return;
      }
      const headerOffset = this.deviceType === 'mobile' ? 72 : 96;
      const targetTop = node.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth',
      });
    },
    getPageUrl (path) {
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${path}`;
      }
      return path;
    },
    isExploreCityAdVisible (key) {
      return !this.hiddenAdSlots[key];
    },
    hideExploreCityAd (key) {
      this.$set(this.hiddenAdSlots, key, true);
    },
    resetExploreCityAds () {
      this.hiddenAdSlots = {};
    },
    renderCityTemplate (template) {
      return renderTemplate(template, this.cityTemplateData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.explore-city {
	background: $color-bg-cream;

	&__container {
		max-width: rem(1080);
		margin: 0 auto;
		padding: rem(40) rem(20) rem(60);
	}

	&__title-block {
		margin-bottom: rem(28);
	}

	&__title {
		font-family: $font-family-serif;
		font-size: rem(52);
		line-height: rem(60);
		font-weight: 700;
		margin: 0;
	}

	&__chips {
		display: flex;
		flex-wrap: wrap;
		gap: rem(12);
		margin-top: rem(16);
	}

	&__chip {
		display: inline-flex;
		align-items: center;
		gap: rem(4);
		padding: rem(6) rem(12);
		border-radius: rem(4);
		background: #000;
		color: #fecd45;
	}

	&__chip-label {
		font-size: rem(14);
		line-height: rem(20);
		font-style: italic;
	}

	&__chip-value {
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 700;
	}

	&__overview {
		display: flex;
		flex-direction: column;
		gap: rem(24);
	}

	&__hero {
		position: relative;
		border-radius: rem(24);
		overflow: hidden;
		border: 1px solid rgba(0, 0, 0, 0.1);
		min-height: rem(420);
	}

	&__hero-image {
		position: absolute;
		inset: 0;
		background-size: cover;
		background-position: center;
	}

	&__hero-overlay {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		padding: rem(24);
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.82) 80%);
		color: #fff;
	}

	&__quote {
		font-family: $font-family-serif;
		font-style: italic;
		font-size: rem(20);
		line-height: rem(30);
		margin: 0;
	}

	&__quote-meta {
		margin-top: rem(16);
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: rem(12);
	}

	&__quote-author {
		font-size: rem(18);
		font-weight: 700;
	}

	&__dots {
		display: inline-flex;
		gap: rem(16);
	}

	&__dot {
		width: rem(8);
		height: rem(8);
		padding: 0;
		border: 0;
		cursor: pointer;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.3);

		&.is-active {
			background: #fff;
		}
	}

	&__metrics {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	&__metric {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: rem(24);
		border-radius: rem(24);
		border: 1px solid #fecd45;
		background: linear-gradient(270deg, rgba(254, 205, 69, 0.2) 0%, rgba(254, 205, 69, 0) 100%);
		box-shadow: 0 rem(4) rem(4) rgba(254, 205, 69, 0.24);
		width: 100%;
		cursor: pointer;
		text-align: left;
		font-family: inherit;
		color: inherit;

		&.is-active {
			background: #fecd45;
		}
	}

	&__metric-left,
	&__metric-right {
		display: inline-flex;
		align-items: center;
		gap: rem(10);
	}

	&__metric-icon {
		width: rem(24);
		height: rem(24);
		flex-shrink: 0;
		object-fit: contain;
	}

	&__metric-name {
		font-size: rem(18);
		line-height: rem(20);
	}

	&__metric-value {
		font-size: rem(26);
		line-height: rem(28);
		font-weight: 500;
	}

	&__metric-arrow {
		width: rem(16);
		height: rem(16);
		flex-shrink: 0;
		object-fit: contain;
	}

	&__details {
		padding-top: rem(24);
		display: flex;
		flex-direction: column;
		gap: rem(24);
	}

	&__ad-block {
		margin-top: rem(16);
	}

	&__ad-block--nav {
		margin-top: 0;
		padding: rem(60) rem(20) 0;
	}

	&__nav-ad {
		margin-top: 0;
	}

	&__ad-block--detail {
		margin-top: 0;
	}

	&__ad-block--related-top {
		margin-top: rem(24);
	}

	&__detail-title {
		font-size: rem(24);
		line-height: rem(32);
		font-weight: 700;
		margin: 0 0 rem(12) 0;
	}

	&__detail-text {
		font-size: rem(16);
		line-height: rem(24);
		margin: 0;
		color: rgba(0, 0, 0, 0.9);
	}

	&__related {
		padding-top: rem(24);
	}

	&__related-title {
		font-size: rem(28);
		line-height: rem(36);
		margin: 0 0 rem(24) 0;
	}

	&__related-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: rem(16);
	}

	&__city-card {
		position: relative;
		display: block;
		height: rem(180);
		border-radius: rem(24);
		overflow: hidden;
		color: #fff;
		text-decoration: none;
		border: 1px solid rgba(0, 0, 0, 0.1);
	}

	&__city-bg {
		position: absolute;
		inset: 0;
		background-size: cover;
		background-position: center;
	}

	&__city-mask {
		position: absolute;
		inset: 0;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0.85) 100%);
	}

	&__city-name {
		position: absolute;
		left: rem(16);
		bottom: rem(14);
		font-size: rem(24);
		font-weight: 700;
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.explore-city {
		&__ad-block--nav {
			padding: rem(60) rem(180) 0;
		}

		&__container {
			padding: rem(40) rem(180) rem(60);
			max-width: none;
		}

		&__overview {
			display: grid;
			grid-template-columns: rem(712) 1fr;
			gap: rem(24);
		}

		&__hero {
			min-height: rem(712);
		}

		&__metrics {
			gap: rem(12);
		}

		&__metric {
			min-height: rem(98);
		}

		&__related-grid {
			grid-template-columns: repeat(4, minmax(0, 1fr));
			gap: rem(24);
		}

		&__city-card {
			height: rem(252);
		}
	}
}

.detect_deviece_mobile {
	.explore-city {
		&__ad-block--nav {
			padding: rem(60) rem(16) 0;
		}

		&__container {
			padding: rem(24) rem(16) rem(48);
		}

		&__overview {
			gap: rem(16);
		}

		&__metrics {
			order: -1;
			flex-direction: row;
			gap: rem(12);
			overflow-x: auto;
			padding-bottom: rem(4);
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__metric {
			flex: 0 0 rem(240);
			min-height: rem(96);
			padding: rem(20);
		}

		&__hero {
			min-height: rem(220);
		}

		&__quote-panel {
			margin-top: rem(16);
			padding: rem(24);
			border: 1px solid rgba(254, 205, 69, 0.72);
			border-radius: rem(24);
			background: rgba(254, 205, 69, 0.12);
		}

		&__quote {
			color: #000;
			font-size: rem(18);
			line-height: rem(30);
		}

		&__quote-meta {
			align-items: center;
		}

		&__quote-author {
			color: #000;
		}

		&__dot {
			background: rgba(0, 0, 0, 0.18);

			&.is-active {
				background: #000;
			}
		}
	}
}
</style>
